function normalizeStatusName(name) {
  return String(name || "").trim().toLowerCase();
}

function matchesAny(text, keywords) {
  return keywords.some((word) => text.includes(word));
}

const SELECTED_KEYWORDS = [
  "final select",
  "selected",
  "cleared",
  "offer",
  "offered",
];

const JOINED_KEYWORDS = ["joined", "onboard", "started", "deployed"];

const REJECTED_KEYWORDS = ["reject", "declined", "dropped", "failed"];

export function mapCandidateStatusOptions(rows = []) {
  return rows.map((row) => ({
    value: row._status_id,
    label: row.status_name,
    isScheduled: row.status_schedule_interview,
  }));
}

export function isInterviewOutcomeSelected(statusName) {
  const normalized = normalizeStatusName(statusName);
  if (!normalized || matchesAny(normalized, REJECTED_KEYWORDS)) {
    return false;
  }
  if (matchesAny(normalized, ["shortlist", "submitted", "scheduled", "pending"])) {
    return false;
  }
  return (
    matchesAny(normalized, SELECTED_KEYWORDS) ||
    (normalized.includes("select") && !normalized.includes("shortlist"))
  );
}

export function findCandidateStatusByIntent(statusOptions = [], intent, currentStatusId) {
  const keywords =
    intent === "joined"
      ? JOINED_KEYWORDS
      : intent === "rejected"
      ? REJECTED_KEYWORDS
      : SELECTED_KEYWORDS;

  const currentId = String(currentStatusId ?? "");

  const scored = statusOptions
    .filter((opt) => String(opt.value) !== currentId)
    .map((opt) => {
      const name = normalizeStatusName(opt.label);
      let score = 0;
      keywords.forEach((keyword, index) => {
        if (name === keyword) score = Math.max(score, 100 - index);
        else if (name.includes(keyword)) score = Math.max(score, 60 - index);
      });
      if (intent === "selected" && name.includes("shortlist")) score = 0;
      return { opt, score };
    })
    .filter((row) => row.score > 0)
    .sort((a, b) => b.score - a.score);

  return scored[0]?.opt || null;
}

export function resolveInterviewStatusSuggestion({
  interviewStatusLabel,
  candidate,
  statusOptions = [],
}) {
  if (!candidate?._candidate_id || !isInterviewOutcomeSelected(interviewStatusLabel)) {
    return null;
  }

  const suggestedStatus = findCandidateStatusByIntent(
    statusOptions,
    "selected",
    candidate.candidate_status_id
  );

  if (!suggestedStatus) return null;

  return {
    source: "interview_selected",
    title: "Suggested status update",
    message: `Interview saved as "${interviewStatusLabel}". Update this candidate's status to "${suggestedStatus.label}"?`,
    suggestedStatus,
    currentStatusName: candidate.status_name || "Unknown",
    showOnboardAction: true,
  };
}

export function resolveOnboardStatusSuggestion({ candidate, statusOptions = [] }) {
  if (!candidate?._candidate_id) return null;

  const suggestedStatus = findCandidateStatusByIntent(
    statusOptions,
    "joined",
    candidate.candidate_status_id
  );

  if (!suggestedStatus) return null;

  return {
    source: "onboard_created",
    title: "Suggested status update",
    message: `Onboard record saved. Mark candidate status as "${suggestedStatus.label}" to reflect joining?`,
    suggestedStatus,
    currentStatusName: candidate.status_name || "Unknown",
    showOnboardAction: false,
  };
}
